module.exports = __webpack_public_path__ + "img/1527833422.8a03b8d5.jpg";